// RoundHeadersColumn.jsx
import React from "react";
import { Box } from "@mui/material";
import RoundHeaderCell from "./RoundHeaderCell";

const RoundHeadersColumn = ({ roundCount }) => {
  return (
    <Box
      className="round-headers-column"
      sx={{
        display: "grid",
        gridTemplateRows: `repeat(${roundCount}, 1fr)`,
        // Keep row gap consistent with main draft grid at XL
        gap: { xs: "1px", sm: "1px", md: "1px", lg: "1px", xl: "1px" },
        mr: { xs: 1, lg: 1, xl: 1 },
      }}
    >
      {Array.from({ length: roundCount }, (_, i) => (
        <RoundHeaderCell key={i} roundNumber={i + 1} />
      ))}
    </Box>
  );
};

export default RoundHeadersColumn;
